import React from 'react'
import { NavLink as Link } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as OrgaoActions } from '$/store/orgao'

class Titulo extends React.Component {
    componentDidMount() {
        const config = JSON.parse(sessionStorage.getItem('config')) || {}
        this.setState({ config })
        if (this.props.orgao.nome === undefined) {
            this.props.buscaInfoOrgao()
        }
    }

    render() {
        return (
            <>
                <div className="titulo">
                    {this.props.children}
                    <h1>
                        <Link to="/">TRANSPARÊNCIA</Link>
                    </h1>
                </div>

                <Link className="containerLogoOrgao" to="/">
                    <img className="logoOrgao" alt="" src={'imagens/logoPortal_' + this.state?.config.cliente + '.png'}></img>
                </Link>
            </>
        )
    }
}

const mapStoreToProps = store => ({
    orgao: store.sistema.orgao.info,
})

const mapDispatchToProps = dispatch => bindActionCreators({ ...OrgaoActions }, dispatch)

export default connect(mapStoreToProps, mapDispatchToProps)(Titulo)
